import { useMemoizedFn } from 'ahooks';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { Loading, Space } from 'tdesign-react';
import { deleteToken, setToken } from '@/utils/storage';
import { fetchIsOrdinaryUserPrompt } from '@/slices/layoutSlice';
import { saveToken } from '@/slices/authSlice';
import { doCiticLogin } from '@/services/authService';
import { fetchFrontConfig } from '@/slices/platformSlice';

function ThirdPartyOauth({ saveToken, fetchIsOrdinaryUserPrompt, fetchFrontConfig }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code = searchParams.get('code');

  const doLogin = useMemoizedFn(async () => {
    deleteToken();
    const { payload: frontConfig } = await fetchFrontConfig(); // 保证最新
    // 中信
    if (frontConfig['third-party-org'] === 'citics') {
      const { data } = await doCiticLogin({ code });
      setToken(data.token);
      saveToken(data.token);
      fetchIsOrdinaryUserPrompt();
      navigate('/cluster');
    }
  });

  useEffect(() => {
    doLogin();
  }, [doLogin]);

  return (
    <Root>
      <Space align='center'>
        <Loading loading />
        页面正在跳转，请稍后...
      </Space>
    </Root>
  );
}

export default connect(null, { saveToken, fetchIsOrdinaryUserPrompt, fetchFrontConfig })(
  ThirdPartyOauth,
);

const Root = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
